import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/data";

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobile = () => {
    setMobileOpen(false);
    setMobileCatOpen(false);
  };

  const linkClass = scrolled
    ? "text-sm font-semibold text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap"
    : "text-sm font-semibold text-white/95 hover:text-primary-300 transition-colors whitespace-nowrap";

  const linkMutedClass = scrolled
    ? "text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
    : "text-sm font-medium text-white/80 hover:text-primary-300 transition-colors whitespace-nowrap";

  const brandClass = scrolled
    ? "font-heading text-xl font-bold tracking-wide whitespace-nowrap text-foreground-900"
    : "font-heading text-xl font-bold tracking-wide whitespace-nowrap text-white drop-shadow-sm";

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-sm shadow-sm"
          : "bg-foreground-950/75 backdrop-blur-sm"
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-8 py-4">
        <Link
          to="/"
          className={brandClass}
        >
          hipobuy.yachts
        </Link>

        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          <Link to="/" className={linkClass}>
            {t("nav.home")}
          </Link>
          <a href="#categories" className={linkClass}>
            Guide d&rsquo;Achat
          </a>
          <a href="#categories" className={linkMutedClass}>
            {t("nav.guides")}
          </a>
          <a href="#articles" className={linkMutedClass}>
            {t("nav.comparatifs")}
          </a>
          <a href="#about" className={linkMutedClass}>
            {t("nav.blog")}
          </a>
          <a href="#faq" className={linkMutedClass}>
            {t("nav.faq")}
          </a>
        </div>

        <div className="hidden md:flex">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-5 py-2.5 bg-primary-500 text-white text-sm font-semibold rounded-md hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            {t("hero.cta.primary")}
          </a>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled ? "text-foreground-800" : "text-white"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-foreground-950/95 backdrop-blur-sm border-t border-white/10 px-4 py-4 flex flex-col gap-2 max-h-[70vh] overflow-y-auto">
          <Link to="/" className="text-white text-sm font-semibold py-2.5 px-2 rounded-md hover:bg-white/10 transition-colors" onClick={closeMobile}>
            <i className="ri-home-4-line mr-2"></i>{t("nav.home")}
          </Link>
          <a href="#categories" className="text-white text-sm font-semibold py-2.5 px-2 rounded-md hover:bg-white/10 transition-colors" onClick={closeMobile}>
            <i className="ri-shopping-bag-3-line mr-2"></i>Guide d&rsquo;Achat
          </a>
          <a href="#categories" className="text-white/80 text-sm py-2.5 px-2 rounded-md hover:bg-white/10 transition-colors" onClick={closeMobile}>
            <i className="ri-grid-line mr-2"></i>{t("nav.guides")}
          </a>
          <a href="#articles" className="text-white/80 text-sm py-2.5 px-2 rounded-md hover:bg-white/10 transition-colors" onClick={closeMobile}>
            <i className="ri-article-line mr-2"></i>{t("nav.comparatifs")}
          </a>

          <button
            className="text-white/80 text-sm py-2.5 px-2 rounded-md hover:bg-white/10 transition-colors flex items-center justify-between"
            onClick={() => setMobileCatOpen(!mobileCatOpen)}
          >
            <span><i className="ri-store-2-line mr-2"></i>Catégories Mode</span>
            <i className={mobileCatOpen ? "ri-arrow-up-s-line text-xs transition-transform" : "ri-arrow-down-s-line text-xs transition-transform"}></i>
          </button>

          {mobileCatOpen && (
            <div className="flex flex-wrap gap-1.5 pl-6 pb-2">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-3 py-1.5 bg-white/10 text-white/85 text-xs rounded-full hover:bg-white/20 transition-colors whitespace-nowrap"
                  onClick={closeMobile}
                >
                  {cat.name}
                </a>
              ))}
            </div>
          )}

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-1 px-5 py-2.5 bg-primary-500 text-white text-sm font-semibold rounded-md text-center whitespace-nowrap"
          >
            {t("hero.cta.primary")}
          </a>
        </div>
      )}
    </nav>
  );
}